/* eslint-disable import/no-anonymous-default-export */
export default [
    {key: 'NewContact', text: 'New Contact'}, 
    {key: 'PendingInfo', text: 'Pending Further Info'},
    {key: 'Disqualified', text: 'Disqualified'}, 
    {key: 'Eligible', text: 'Eligible'}
  ];